import React, { FC } from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { SelfIntroductionInfoStatus } from 'generated/graphql'
import Button from '@app.components/Button'
import useLoadSelfIntroduction from '@app.feature/coverletter/coverletter.write/hook/useLoadSelfIntroduction'
import CoverLetterWrite from 'svgIcons/CoverLetterWrite'
import { useDutyModalStore } from '../../../store/dutyModal'

const CreateButton: FC = () => {
  const { query } = useRouter()
  const loadSelfIntroduction = useLoadSelfIntroduction({
    openNewTab: true,
  })
  const closeModal = useDutyModalStore((store) => store.closeModal)

  const selectedStatus =
    query.selfIntroductionStatus as SelfIntroductionInfoStatus

  const handleCreateButtonClick = () => {
    loadSelfIntroduction({
      callback: () => closeModal(),
      variables: {
        input: {
          title: '새 자기소개서',
          selfIntroductionInfoInput: selectedStatus
            ? {
                status: selectedStatus,
              }
            : undefined,
          qnas: [
            {
              question: '',
              answer: '',
              charMaxSize: 1000,
            },
          ],
        },
      },
    })
  }

  return (
    <StyledWrapper>
      <Button
        startIcon={<CoverLetterWrite />}
        className="create-button"
        onClick={handleCreateButtonClick}
      >
        새 자소서 작성
      </Button>
    </StyledWrapper>
  )
}

export default CreateButton

const StyledWrapper = styled.span`
  .create-button {
    width: 150px;
    font-size: 12px;
    font-weight: bold;
    padding: 12px 20px;
  }
`
